<template>
  <base-button class="btn-primary" text="送信" type="submit" />
</template>

<script>
import BaseButton from "@/views/atoms/BaseButton";

export default {
  name: 'SendButton',
  components: {
    BaseButton
  },
}
</script>
